import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import PropTypes from 'prop-types';
import * as authActions from '../provider/reducer';

export function Root(App, data) {
    return class extends Component{
      static get propTypes() {
        return {
          auth: PropTypes.shape({
            isLoggedIn: PropTypes.bool.isRequired,
          }),
          fetchAuth: PropTypes.func.isRequired
        };
      }
      constructor(props) {
          super(props);
      }
      componentWillMount() {
          this.props.fetchAuth();
          }        
      render(){
        const { auth } = this.props;
          return auth.isLoggedIn ? <App {...this.props}/> : <div/>;
      }
    }    
}
const mapStateToProps = state => ({
  auth: {...state.auth}
});

const mapDispatchToProps = (dispatch) => {
  const {
    fetchAuthIfNeeded,
  } = bindActionCreators(authActions, dispatch);

  return {
    fetchAuth: fetchAuthIfNeeded,
  };
};
const RootApp = compose(connect(
  mapStateToProps,
  mapDispatchToProps
),Root);

export {RootApp};


// WEBPACK FOOTER //
// ./src/utility/rootapp.js